import React from 'react';
import Lottie from 'lottie-react';
import animationData from './Talo_Loading.json';

interface LoadingIndicatorProps {
  className?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ className }) => {
  return (
    <div className={`flex items-center justify-center ${className ?? ''}`}>
      <Lottie animationData={animationData} loop autoplay style={{ width: 160, height: 160 }} />
    </div>
  );
};

export default LoadingIndicator;
